module.exports = __webpack_public_path__ + "img/pick2.d210f105.png";